import React from 'react';
import { Link } from "react-router-dom";
import { Chart } from '../chart/Chart';


export function Dashboard() {

  return (

    <div className="font-body space-y-8 animate-in fade-in duration-300">


      {/* Top Greeting Header */}

      <div className="
        flex 
        flex-col 
        md:flex-row 
        md:items-center 
        md:justify-between 
        gap-4 
        bg-white 
        border 
        border-border 
        p-6 
        rounded-card 
        shadow-sm
      ">


        <div>

          <h1 className="
            font-display 
            text-h2 
            font-bold 
            text-text-primary 
            mb-1
          ">
            Bom dia, Silvana
          </h1>


          <p className="text-text-secondary text-body">
            Tudo sob controle para impulsionar sua jornada hoje.
          </p>


          {/* Ações rápidas */}

          <div className="flex gap-3 mt-4">


            <Link
              to="/contatos"
              className="
                bg-primary
                text-white
                px-4
                py-2
                rounded-button
                text-small
                font-semibold
                hover:opacity-90
                transition
              "
            >
              + Novo Contato
            </Link>


            <button
              className="
                border
                border-border
                px-4
                py-2
                rounded-button
                text-small
                font-semibold
                text-text-primary
                hover:bg-background
                transition
              "
            >
              + Nova Venda
            </button>


          </div>


        </div>



        {/* Hoje Quick Summary */}

        <div className="
          flex 
          items-center 
          gap-6 
          divide-x 
          divide-border 
          bg-background 
          px-5 
          py-3 
          rounded-button
        ">


          <div>

            <p className="
              text-caption 
              text-text-secondary 
              font-medium 
              uppercase 
              tracking-wider
            ">
              Hoje
            </p>

            <p className="
              text-body 
              font-bold 
              text-primary
            ">
              8 tarefas
            </p>

          </div>



          <div className="pl-6">

            <p className="
              text-caption 
              text-text-secondary 
              font-medium 
              uppercase 
              tracking-wider
            ">
              Compromissos
            </p>


            <p className="
              text-body 
              font-bold 
              text-primary
            ">
              2 reuniões
            </p>

          </div>




          <div className="pl-6">

            <p className="
              text-caption 
              text-text-secondary 
              font-medium 
              uppercase 
              tracking-wider
            ">
              Negócios
            </p>


            <p className="
              text-body 
              font-bold 
              text-primary
            ">
              4 leads novos
            </p>

          </div>


        </div>


      </div>





      {/* KPI Cards Section */}

      <section className="space-y-4">


        <h2 className="
          font-display 
          text-h4 
          font-bold 
          text-text-primary
        ">
          KPIs Financeiros & Vendas
        </h2>



        <div className="
          grid 
          grid-cols-1 
          sm:grid-cols-2 
          lg:grid-cols-4 
          gap-4
        ">


          <div className="
            bg-white 
            border 
            border-border 
            p-6 
            rounded-card 
            shadow-sm
          ">

            <p className="
              text-caption 
              text-text-secondary 
              font-semibold 
              uppercase 
              tracking-wider 
              mb-2
            ">
              Faturamento Mensal
            </p>


            <p className="
              text-h3 
              font-display 
              font-bold 
              text-text-primary
            ">
              R$ 45.230
            </p>


          </div>





          <div className="
            bg-white 
            border 
            border-border 
            p-6 
            rounded-card 
            shadow-sm
          ">

            <p className="
              text-caption 
              text-text-secondary 
              font-semibold 
              uppercase 
              tracking-wider 
              mb-2
            ">
              Conversão de Leads
            </p>


            <p className="
              text-h3 
              font-display 
              font-bold 
              text-text-primary
            ">
              18.6%
            </p>


          </div>





          <div className="
            bg-white 
            border 
            border-border 
            p-6 
            rounded-card 
            shadow-sm
          ">


            <p className="
              text-caption 
              text-text-secondary 
              font-semibold 
              uppercase 
              tracking-wider 
              mb-2
            ">
              Novos Contratos
            </p>


            <p className="
              text-h3 
              font-display 
              font-bold 
              text-text-primary
            ">
              14 ativos
            </p>


          </div>





          <div className="
            bg-white 
            border 
            border-border 
            p-6 
            rounded-card 
            shadow-sm
          ">


            <p className="
              text-caption 
              text-text-secondary 
              font-semibold 
              uppercase 
              tracking-wider 
              mb-2
            ">
              Custo de Aquisição (CAC)
            </p>


            <p className="
              text-h3 
              font-display 
              font-bold 
              text-text-primary
            ">
              R$ 142
            </p>


          </div>


        </div>


      </section>





      {/* Charts */}

      <div className="
        grid 
        grid-cols-1 
        lg:grid-cols-3 
        gap-6
      ">


        <div className="
          lg:col-span-2 
          space-y-6
        ">


          <Chart
            title="Desempenho Geral de Vendas"
            type="line"
            data={[30,48,42,65,58,85,92]}
          />


        </div>



        <div>

          <section className="
            bg-white
            border
            border-border
            p-6
            rounded-card
            shadow-sm
          ">

            <h3 className="
              text-body
              font-bold
              text-text-primary
            ">
              Próximos passos
            </h3>


            <p className="
              text-small
              text-text-secondary
              mt-2
            ">
              Cadastre clientes, vendas e projetos para alimentar seu painel.
            </p>


          </section>


        </div>


      </div>



    </div>

  );

}